var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTickCircle = function SvgTickCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Z",
    fill: "rgb(var(--tw-color-primary-200))"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m17.676 10.237-6 5.5a1 1 0 0 1-1.383-.03l-3-3a1 1 0 1 1 1.414-1.414l2.323 2.323 5.294-4.853a1 1 0 1 1 1.352 1.474Z",
    fill: "rgb(var(--tw-color-primary-900))"
  })));
};
export default SvgTickCircle;